const Tabs = ({ tabs, activeTab, onChange, className = '' }) => {
  return (
    <div className={`border-b border-slate-200 dark:border-slate-800 ${className}`}>
      <div className="flex gap-1 overflow-x-auto snap-x snap-mandatory -mb-px">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm whitespace-nowrap snap-start border-b-2 transition-colors ${
                isActive
                  ? 'border-primary-600 text-primary-700 dark:text-primary-300 font-semibold'
                  : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 hover:border-slate-300 dark:hover:border-slate-700'
              }`}
              aria-selected={isActive}
              role="tab"
            >
              <span>{tab.label}</span>
              {tab.hint ? (
                <span
                  className={`text-[10px] font-medium ${
                    tab.hintColor === 'warning'
                      ? 'text-warning-600 dark:text-warning-300'
                      : 'text-slate-400 dark:text-slate-400'
                  }`}
                >
                  ({tab.hint})
                </span>
              ) : typeof tab.count === 'number' ? (
                <span
                  className={`text-[10px] font-medium ${
                    isActive
                      ? 'text-primary-600 dark:text-primary-300'
                      : 'text-slate-400 dark:text-slate-400'
                  }`}
                >
                  ({tab.count})
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
